(() => {
  if (window.lnPremiumAccessReady) return;
  window.lnPremiumAccessReady = true;
  const sync = () => {
    document.querySelectorAll('[data-ln-premium-menu]').forEach(link => {
      const dialog = link.closest('dialog');
      const primary = dialog?.querySelector('.ln-menu-primary');
      if (!primary) return;
      const target = new URL(link.href, location.origin);
      const existing = [...primary.querySelectorAll('a[href]')].find(anchor => anchor !== link && new URL(anchor.href, location.origin).pathname.replace(/\/$/, '') === target.pathname.replace(/\/$/, ''));
      if (existing) {link.remove();return;}
      if (link.parentElement !== primary || primary.firstElementChild !== link) primary.prepend(link);
    });
  };
  let queued = false;
  const schedule = () => {if (queued) return;queued = true;queueMicrotask(() => {queued = false;sync();});};
  sync();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('toggle', event => {if (event.target.matches?.('dialog[data-modal="menu"]')) sync();}, true);
})();
